import * as React from "react";

interface LabelProps {
  labelText: string;
  formInputType?: "input" | "select" | "div" | "";
  formInputName?: string;
  customLabelStyle?: string;
  className?: string;
}

const Label: React.FC<LabelProps> = ({
  labelText,
  formInputType = "",
  formInputName = "",
  customLabelStyle,
  className = "",
}) => (
  <label
    className={`text-color-teal font-body font-medium my-0 mx-2 ${formInputType === "input" || formInputType === "select"
        ? " text-xs-1 tracking-caption"
        : " text-md-2 tracking-body-text leading-body-text"

      } ${className} ${customLabelStyle}`}
    htmlFor={`${formInputType}__${formInputName}`}
  >
    {labelText}
  </label>
);

export default Label;
